import Icon from '../components/Icon.vue'

Icon.register({
  check: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M173.9 439.4L7.5 273C-2.5 263-2.5 246.8 7.5 236.8L43.7 200.6C53.7 190.6 69.9 190.6 79.9 200.6L192 312.7 432.1 72.6C442.1 62.6 458.3 62.6 468.3 72.6L504.5 108.8C514.5 118.8 514.5 135 504.5 145L210.1 439.4C200.1 449.4 183.9 449.4 173.9 439.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/check.js
// module id = D/Bo
// module chunks = 144